var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightGradientIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53036 6.54846L0.480359 0.260965C0.459324 0.244405 0.434044 0.234113 0.407424 0.231272C0.380803 0.228432 0.353922 0.233156 0.329866 0.244905C0.30581 0.256653 0.285555 0.274948 0.271428 0.297689C0.257301 0.32043 0.249875 0.346694 0.250002 0.373465V1.75382C0.250002 1.84132 0.291073 1.92525 0.35893 1.97882L6.7875 6.99846L0.35893 12.0181C0.289287 12.0717 0.250002 12.1556 0.250002 12.2431V13.6235C0.250002 13.7431 0.387502 13.8092 0.480359 13.736L8.53036 7.44847C8.59878 7.39509 8.65413 7.32682 8.6922 7.24885C8.73027 7.17087 8.75005 7.08524 8.75005 6.99846C8.75005 6.91169 8.73027 6.82606 8.6922 6.74808C8.65413 6.67011 8.59878 6.60184 8.53036 6.54846Z",
    fill: "url(#paint0_linear_3401_3777)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3401_3777",
    x1: 0.536659,
    y1: -4.77204,
    x2: 9.43084,
    y2: -4.59869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC165"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGradientIcon);
export default __webpack_public_path__ + "static/media/right-gradient-icon.72227621c1c2372bca37a1229719e241.svg";
export { ForwardRef as ReactComponent };